import * as React from 'react';
import * as Glob from '../Globale';
import * as Compat from '../Compat';
import { BaseComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { Trad, BottoneAPI } from '../components/';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import { CampoData, CampoNumero, BasePureDeroga } from '../components/';

interface IDerogaProps extends Dati.IBaseProps {
    Valore: Dati.TListaParametriDeroga;
    Tipo: string;
    ID: number;
}

interface IDerogaState {
    Tipo: string;
    ListaValori: Dati.TListaParametriDeroga;//Dati.Dictionary<any>;
    Note: string;
    ID: number;
}

export class Deroga extends BasePureDeroga<IDerogaProps, IDerogaState> {

    private _Visible: number = 0;

    constructor(props: any) {
        super(props);
        this.state = { Tipo: this.props.Tipo, ListaValori: {}, Note: "", ID: this.props.ID };
        this._Visible = 0;
        this.OnChange = this.OnChange.bind(this);
        this.OnInvioDeroga = this.OnInvioDeroga.bind(this);
        this.OnClickDeroga = this.OnClickDeroga.bind(this);
        this.OnErroreBottoneAPI = this.OnErroreBottoneAPI.bind(this);
    }

    public componentDidMount() {
        this.LoadValues();
    }

    private LoadValues() {
        this._Visible = 0;
        this.setState({ Tipo: this.props.Tipo, ListaValori: {}, ID: this.props.ID })
        if (this.props.ID > 0) {
            for (var i in this.props.Valore) {
                if (this.props.Valore[i]) {
                    this._Visible++;
                }
            }
        }
    }


    private OnInvioDeroga(sender: BottoneAPI): any {
        //console.warn("STATE: ", this.state);
        return this.state;
    }

    private OnClickDeroga(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad("DEROGA"), "Richiesta deroga inserita correttamente");
        }
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
        return false;
    }

    protected OnChangeNote(e: React.FormEvent<any>): any {
        this.setState({ Note: e.currentTarget.value })
    }

    public render() {
        let valori: any[] = [];
        this._Visible = 0;
        for (var i in this.props.Valore) {
            if (this.props.Valore[i]) {
                if (this.state.ListaValori[i] == undefined)
                    this.state.ListaValori[i] = this.props.Valore[i];
                this._Visible = 1;
                valori.push(this.CampoNew(i, this.props.Valore[i].Tipo, this.state.ListaValori));//valori.push(this.Campo(i, this.state.ListaValori));
            }
        }

        valori.push(this.Decora(Trad.Trad("Note deroga"), <textarea className="form-control" value={this.state.Note} id="Note" name="Note" onChange={(e) => this.OnChangeNote(e)} rows={4} />));

        let div: any[] = [];
        div.push(<div className="modal fade" id="modaleDerogaInfo" role="dialog" aria-labelledby="modalDerogaInfo" key={0}>
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header alert-info" id="modalDerogaTestata">
                        <span className="kt-portlet__head-icon">
                            <i className="flaticon-edit-1"> </i>
                        </span>
                        <h3 className="modal-title" id="modaleDerogaTitolo">{Trad.Trad('Deroga')}: {Trad.Trad(this.props.Tipo)}</h3>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body" id="modaleDerogaTesto">
                        {valori}
                    </div>
                    <div className="modal-footer">
                        <BottoneAPI Default={false} Testo={Trad.Trad("Richiedi")} URL="/api/Deroga" Metodo="POST" OnInvio={(s) => this.OnInvioDeroga(s)} OnClick={(s, d) => this.OnClickDeroga(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} Visibile={this._Scrittura} ClasseAttivo="btn btn-success" DataDismiss="modal" />
                    </div>
                </div>
            </div>
        </div>);
        div.push(<button key={1} className={"btn btn-metal " + (this._Visible > 0 ? "" : "hidden")} type="button" data-toggle="modal" title={Trad.Trad('Richiedi deroga')} data-target="#modaleDerogaInfo" id="btnModaleDerogaInfo">
            <span>
                <i className="fa fa-level-up-alt"></i>
                <span> {Trad.Trad('RichiediDeroga')}</span>
            </span>

        </button>);

        return div;
    }
}


// WEBPACK FOOTER //
// ./src/components/Deroga.tsx